import {useEffect, useState} from "react";
import {CheckIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsPresignupApproveModal = (props: {
    active: boolean,
    closeHandler: any,
    studentId: number,
    name: string,
    onDone: any,
    decline:boolean,
}) => {
    const [sms,setSms] = useState(true);
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setSms(true);
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const id = props.studentId;
        const s = sms ? '1' : '0';
        const decline = props.decline;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/presignup/' + (decline ? 'decline':'approve'),
            {
                id:id.toString(),
                sms:s,
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                props.closeHandler();
                ShowSnackbar(
                    decline ? 'رد درخواست دانش آموز صادر شد.' : 'ثبت نام دانش‌آموز تایید شد.',
                    'باشه',
                    5000,
                );
                props.onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top:20}}>
                <div className="web-modal-header">
                    <div><b>{props.decline ? 'رد درخواست' : 'تایید درخواست'}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label>نام دانش‌آموز:</label>
                        <input type="text" disabled={true}
                               className="form-control"
                               value={props.name}
                        />
                        <div style={{height: 20}}/>
                        <label>کد رهگیری:</label>
                        <input type="text" disabled={true}
                               className="form-control"
                               value={"14050" + props.studentId.toString()}
                        />
                        <div style={{height: 20}}/>
                        <button className={"techaran-checkbox" + (sms ? ' active':'')}
                        onClick={()=>setSms(v=>!v)}>
                            <i><CheckIcon/></i>
                            <span>ارسال پیامک
                                <em>اطلاع رسانی فوری به والدین.</em>
                            </span>
                        </button>
                        <div className="d-flex justify-content-end align-items-center" style={{gap:5,marginTop:15}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className={props.decline ? 'remove-button' : "btn-pay"} onClick={saveChanges}>
                                <b>{props.decline ? 'رد درخواست' : 'تایید درخواست'}</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};